import { apiPathFunc } from "@api/util/apiPathFunc";

import { cancel } from "./cancel/path";
import { exportPDF } from "./exportPDF/path";
import { subscriptionInstallments } from "./installments/path";
import { settleInstallments } from "./settleInstallments/path";

import type { IExtractParams } from "@routes";

const pathBase = `/subscriptions/`;
const pathById = `${pathBase}:subscriptionId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const subscriptions = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  settleInstallments,
  exportPDF,
  cancel,
  subscriptionInstallments,
};
